export function scrollBottom() {
    setTimeout(() => {
        window.scroll({top: document.body.scrollHeight, behavior: 'smooth'});
    }, 200);
}